<template>
  <div class="share-popup">
    <van-nav-bar
      class="file-header nav-bar-bgcolor"
      :title="title"
      :left-text="$t('base.cancel')"
      @click-left="handleClose"
      v-if="!$route.query.invite"
    />
    <van-nav-bar
      :class="{'file-header': true, 'nav-bar-bgcolor': true}"
      :title="$t('collab.colleagues')"
      :left-text="$t('base.cancel')"
      @click-left="handleClose('invite')"
      v-if="$route.query.invite"
    />
    <div :class="{'share-content': true, 'invite-wrap': $route.query.invite}">
      <div class="file-list">
        <file-item
          :item="actionItem"
          :hideAction="true"
          :noBorder="true"
          :disableClickStyle="true"
          scenario="share"
          v-if="!$route.query.invite"
        />
      </div>
      <template v-if="!$route.query.invite">
        <div
          class="share-version"
          v-if="share_is_pro && actionItem.type !== 'folder' && actionItem.extension !== 'ydoc' && actionItem.extension !== 'yxls'"
        >
          <check-box v-model="current_version">
            {{$t('file.share.current.checkbox')}}
            <span
              v-if="fileVersion"
              class="current-version primary-color primary-bdcolor"
            >V{{fileVersion}}</span>
          </check-box>
          <span class="hint">{{$t('file.share.current.tooltip.1')}}</span>
        </div>
        <div class="share-version" v-else>
          <span class="hint">{{$t('file.share.latest')}}</span>
        </div>
      </template>
      <div v-if="actionName !== 'link'" class="select-contact">
        <div class="settings-title">
          <span>{{$t('file.share.selectContact')}}</span>
          <span v-if="$route.query.invite" class="setting-more">({{$t('collab.choose.more')}})</span>
        </div>
        <ul>
          <li v-for="id in selectList" :key="id">
            <avatar
              v-if="selectEntities[id].is_department"
              class="thumb-icon"
              type="department"
              :size="50"
            />
            <avatar
              v-else-if="selectEntities[id].is_group"
              class="thumb-icon"
              type="group"
              :size="50"
            />
            <avatar
              v-else
              class="thumb-icon"
              :user="selectEntities[id]"
              :isActive="selectEntities[id].is_active"
              :size="50"
            />
            <div class="contact-name ellipsis">{{selectEntities[id].name}}</div>
          </li>
          <li @click="toggleContactSelect">
            <svg-icon icon="add_person" cls="svg-contact" />
          </li>
          <li @click="toggleSelectRemove">
            <svg-icon v-if="selectList.length" icon="Delete_person" cls="svg-contact" />
            <!-- <li v-if="selectList.length" class="remove-contact" @click="toggleSelectRemove"> -->
          </li>
        </ul>
      </div>
      <div class="permission-settings" v-if="!$route.query.invite">
        <div class="settings-title">{{$t('file.share.permissionSettings')}}</div>
        <div @click="toggleChangePerms" class="settings-content">
          <ul>
            <li>
              <i class="iconfont icon-Permission_personx"></i>
              {{personText}}
            </li>
            <li>
              <i class="iconfont icon-Permission_downloadx"></i>
              {{downloadText}}
            </li>
            <li>
              <i class="iconfont icon-Permission_timex"></i>
              {{perms.due_time ? (expired ? $t('file.share.outOfDate') : $t('file.share.expiresAfter', [expireDate])) : $t('file.share.neverExpire')}}
            </li>
            <li>
              <i class="iconfont icon-Permission_lockx"></i>
              {{pswText}}
            </li>
            <!-- <li v-if="actionName === 'link'">
              <i class="iconfont icon-safety-watermark"></i>
              {{perms.is_watermark_customize_content ? $t('file.share.showPreviewWatermark', [perms.watermark_customize_content]) : $t('file.share.hideWatermark')}}
            </li> -->
          </ul>
          <i class="iconfont icon-arrow-next"></i>
        </div>
      </div>
      <template v-if="$route.query.invite">
        <div class="add-message-action">
          <div class="add-message-content" @click="toggleChangeCollabLevel">
            {{$t('collab.roles.choose')}}
            <span class="hint">
              {{$t(store.collabState.roleMessage[currentRoleLevel])}}
              <i
                class="iconfont icon-arrow-next"
              ></i>
            </span>
          </div>
        </div>
        <div class="add-message-tip">{{$t('collab.colleagues.tip')}}</div>
      </template>
      <div class="add-message-action">
        <div class="add-message-content" @click="toggleAddMessage">
          {{$t('file.share.message')}}
          <span class="hint">
            {{messageTextTip}}
            <i class="iconfont icon-arrow-next"></i>
          </span>
        </div>
      </div>
    </div>
    <div
      :class="['action-bar', 'primary-color', disabled && 'disabled']"
      @click="handleActionBar"
    >{{actionBarText}}</div>
    <van-popup
      class="change-perms-view"
      v-model="showChangePermsSm"
      position="right"
      :close-on-click-overlay="false"
    >
      <change-perms-share-manager
        v-if="showChangePermsSm"
        :actionItem="actionItem"
        :actionName="actionName"
        :actionFrom="actionFrom"
        @close-popup="toggleChangePerms"
        v-model="perms"
      />
    </van-popup>
    <van-popup
      class="change-perms-view"
      v-model="showChangePerms"
      position="right"
      :close-on-click-overlay="false"
    >
      <change-perms
        v-if="showChangePerms"
        :actionItem="actionItem"
        :actionName="actionName"
        :actionFrom="actionFrom"
        @close-popup="toggleChangePerms"
        v-model="perms"
      />
    </van-popup>
    <van-popup class="add-message-view" v-model="showAddMessage" position="right">
      <add-message
        :actionItem="actionItem"
        :actionName="actionName"
        :actionFrom="actionFrom"
        :show="showAddMessage"
        :description="description"
        @close-add-message="editMessage"
      />
    </van-popup>
    <van-popup class="contact-select-view" v-model="showContactSelect" position="bottom">
      <contact-select
        v-if="showContactSelect"
        :selectListProp="selectList"
        :selectEntitiesProp="selectEntities"
        @close-popup="toggleContactSelect"
        @add-contact="onAdd"
      />
    </van-popup>
    <van-popup class="contact-remove-view" v-model="showContactRemove" position="right">
      <contact-remove
        v-if="showContactRemove"
        :selectListProp="selectList"
        :selectEntitiesProp="selectEntities"
        @close-popup="toggleSelectRemove"
        @remove-contacts="handleRemoveItems"
      />
    </van-popup>
  </div>
</template>
<script>
import { i18n } from '@/utils/i18n'
import {
  alert,
  toast,
  formatDate,
  getDefaultDueTime,
  loading,
  pageShare,
  getPageShareIcon,
  loadingWithoutUserInterface
} from '@/utils/common'
import config from '@/config'
import FileItem from '../file/FileItem'
import CheckBox from '../utils/CheckBox'
import ChangePerms from './ChangePerms'
import ChangePermsShareManager from './ChangePermsShareManager'
import AddMessage from './AddMessage'
import ContactSelect from '../contact/ContactSelect'
import ContactRemove from '../contact/ContactRemove'
import ajax from '@/utils/ajax'
import { CREATE_SHARE, VERSIONS_INFO, COLLAB_INVITE } from '@/config/api'
import Avatar from '../utils/Avatar'
import Clipboard from 'clipboard'
import SvgIcon from '../utils/SvgIcon'
import { Toast } from 'vant'
import ShareUtils from '../../utils/ShareUtils'

const titles = {
  colleague: i18n.t('file.share.sendToColleague'),
  Wechat: `${i18n.t('share.with')} ${i18n.t('share.Wechat')}`,
  EnterpriseWechat: `${i18n.t('share.with')} ${i18n.t(
    'share.EnterpriseWechat'
  )}`,
  link: i18n.t('file.share.copyLinkConfirm')
}
export default {
  name: 'SharePopup',
  components: {
    FileItem,
    CheckBox,
    ChangePerms,
    ChangePermsShareManager,
    AddMessage,
    ContactSelect,
    ContactRemove,
    Avatar,
    SvgIcon
  },
  i18n,
  props: {
    actionName: String,
    actionItem: Object,
    actionFrom: String,
    shareActionCategory: String
  },
  data () {
    return {
      headerItem: {},
      listInfo: {},
      newFolder: {},
      current_version: false,
      share_is_pro: config.enterprise_info.plan_functional_type === 'pro',
      showChangePerms: false,
      showChangePermsSm: false,
      showAddMessage: false,
      description: '',
      group_ids: [],
      invited_user_ids: [],
      selectList: [],
      selectEntities: {},
      fileVersion: '',
      perms: this.generatePerms(this.actionItem),
      showContactSelect: false,
      showContactRemove: false,
      currentRoleLevel: 'editor'
    }
  },
  computed: {
    title () {
      return titles[this.shareActionCategory]
    },
    expired () {
      return this.perms.due_time && this.perms.due_time * 1000 < +new Date()
    },
    expireDate () {
      return formatDate(this.perms.due_time * 1000, '%L')
    },
    disabled () {
      const { invite } = this.$route.query
      // 在分享给同事 或者 协作邀请的时候 判断 selectList
      return (
        (this.actionName === 'colleague' || invite) && !this.selectList.length
      )
    },
    personText () {
      let text = ''
      if (this.actionName !== 'link') {
        text = i18n.t('file.share.onlySpecificColleagueCanVisit')
      } else if (this.actionItem.is_share_management && this.actionName === 'link') {
        text = i18n.t(this.perms.access === 'public' ? 'file.share.anyone' : 'file.share.memberOnly')
      } else {
        text = i18n.t(this.perms.access === 'public' ? 'file.share.anyoneCanAccess' : 'file.share.memberOnlyAccess')
      }
      return text
    },
    downloadText () {
      let text = ''
      if (this.actionItem.is_share_management && this.actionName === 'link') {
        text = this.perms.disable_download
          ? i18n.t('file.share.downloadableType2', [
            this.perms.is_preview_limit && this.perms.preview_limit > 0
              ? this.perms.preview_limit
              : i18n.t('file.share.noLimit')
          ])
          : i18n.t('file.share.downloadableType1', [
            this.perms.is_preview_limit && this.perms.preview_limit > 0
              ? this.perms.preview_limit
              : i18n.t('file.share.noLimit'),
            this.perms.is_download_limit_v2 &&
              this.perms.download_limit_v2 > 0
              ? this.perms.download_limit_v2
              : i18n.t('file.share.noLimit')
          ])
      } else {
        if (this.perms.disable_download) {
          text = i18n.t('file.share.canOnlyPreview')
        } else {
          text = i18n.t('file.share.canPreviewAndDownload')
        }
      }

      if (this.perms.is_share_wps_edit) {
        text += '和可在线编辑'
      }
      return text
    },
    pswText () {
      let text = ''
      if (this.actionItem.is_share_management && this.actionName === 'link') {
        text = this.perms.password ? i18n.t('file.share.passwordIs', [this.perms.password]) : i18n.t('file.share.noPassword')
      } else {
        text = this.perms.password ? i18n.t('file.share.havePassword') : i18n.t('file.share.noPassword')
      }
      return text
    },
    enableClipboardJS () {
      return Clipboard.isSupported()
    },
    messageTextTip () {
      if (this.description.length) {
        return i18n.t('base.modify')
      } else {
        return i18n.t('file.share.optional')
      }
    },
    actionBarText () {
      let text

      if (this.$route.query.invite) {
        text = 'base.send'
      } else {
        text =
          this.shareActionCategory !== 'link'
            ? 'file.action.share'
            : 'file.share.generateLink'
      }
      return i18n.t(text)
    }
  },
  watch: {
    $route (to, from) {
      this.showChangePerms = !!to.query.changeperms
      this.showChangePermsSm = !!to.query.changepermssm
      this.showAddMessage = !!to.query.addmessage
      this.showContactSelect = !!to.query.contactselect
      this.showContactRemove = !!to.query.contactremove
    },
    'store.collabState' (state) {
      this.currentRoleLevel = state.currentRoleLevel
    }
  },
  created () {
    if (this.actionItem.type === 'file') {
      this.fetchVersions()
    }
  },
  methods: {
    onListInfoChange (info) {
      this.listInfo = info
      if (['own', 'collab', 'external'].includes(info.space)) {
        this.headerItem = { ...this.headerItem, permissions: info.permissions }
      }
      if (info.space === 'external') {
        this.headerItem.name = info.current_path[0].name
      }
    },
    onHeaderItemChange (item) {
      this.headerItem = item
    },
    generatePerms (item) {
      let perms = {
        is_share_wps_edit: false
      }
      if (item.is_share_management && this.actionName === 'link') {
        // 开启了分享管控
        // 分享对象限制
        if (item.is_share_link_public_access_disabled) {
          perms.access = 'company'
        } else {
          if (item.is_share_default_public_access_disabled) {
            perms.access = 'company'
          } else {
            perms.access = 'public'
          }
        }

        // 访问权限设置
        perms.disable_download = !!item.is_share_link_download_disabled
        if (!perms.disable_download) {
          perms.disable_download = !!item.is_share_default_download_disabled
        }

        // 预览下载次数限制设置
        perms.is_preview_limit = perms.is_download_limit_v2 =
          item.is_share_force_op_limit_switch
        if (item.share_default_preview_limit > 0) {
          perms.preview_limit = item.share_default_preview_limit
        } else {
          perms.preview_limit = 10
        }
        if (item.share_default_download_limit > 0) {
          perms.download_limit_v2 = item.share_default_download_limit
        } else {
          perms.download_limit_v2 = 10
        }

        // 访问期限设置
        if (item.share_default_due_time === 0) {
          perms.due_time = 0
        } else if (item.share_default_due_time > 0) {
          perms.due_time =
            parseInt(Date.now() / 1000) + item.share_default_due_time
        } else {
          perms.due_time = getDefaultDueTime()
        }

        // 密码设置
        if (item.is_share_force_passwd_switch) {
          perms.password = ShareUtils.generatePsw()
        } else {
          perms.password = ''
        }

        // 水印设置
        if (
          item.is_share_watermark_customize_content_switch ||
          item.is_share_watermark_creator_account
        ) {
          // 这个字段其实是用来表示shareLink有没有水印，而不是用来表示有没有自定义水印
          perms.is_watermark_customize_content = true
          perms.watermark_customize_content = ShareUtils.getFixedWatermark(item)
        } else {
          perms.is_watermark_customize_content = false
          perms.watermark_customize_content = ''
        }
      } else {
        // 普通的分享
        perms.access =
          this.actionName === 'link'
            ? this.actionItem.is_share_link_public_access_disabled
              ? 'company'
              : 'public'
            : 'collaborators'
        perms.due_time = getDefaultDueTime()
        perms.disable_download = !!this.actionItem
          .is_share_link_download_disabled
        perms.password = ''
      }
      return perms
    },
    handleClose (type) {
      if (type === 'invite') return this.toggleQuery('invite')
      this.$emit('close-share')
    },
    handleSendCollabInvite () {
      if (!this.selectList.length) return
      const invited_groups = []
      const invited_users = []

      this.selectList.forEach(item => {
        const splitedList = item.split('-')

        if (splitedList[0] === 'contact') {
          invited_users.push(`${splitedList[1]}:${this.currentRoleLevel}`)
        } else if (splitedList[0] === 'department') {
          invited_groups.push(
            `${this.selectEntities[item]['group_id']}:${this.currentRoleLevel}`
          )
        } else {
          invited_groups.push(`${splitedList[1]}:${this.currentRoleLevel}`)
        }
      })
      // 群组与部门都划分为 group
      const data = {
        folder_id: this.$route.params.id,
        invitation_message: this.description,
        invited_groups: invited_groups.join(';'),
        invited_users: invited_users.join(';')
      }
      let loadingStatus = loading(i18n.t('base.sending'))

      ajax({
        url: `${COLLAB_INVITE}?_=${new Date().getTime()}`,
        data,
        method: 'POST',
        accept_all_errors: true
      }).then(result => {
        loadingStatus.clear()
        // 邀请加入协作文案显示
        const {
          reduce_coowner_permission_users = [],
          accepted_collaborated_users = [],
          accepted_collaborated_groups = [],
          collab_groups_info = [],
          collab_users_info = []
        } = result
        const acceptedList = [
          ...accepted_collaborated_users,
          ...accepted_collaborated_groups
        ]
        const permissionErrorList = [
          ...reduce_coowner_permission_users,
          ...acceptedList
        ]
        const successCount =
          collab_groups_info.length + collab_users_info.length
        const errorCount = this.selectList.length - successCount
        const coownerPremissionListByName = reduce_coowner_permission_users.map(
          item => item.name
        )
        const acceptedListByName = acceptedList.map(item => item.name)

        if (permissionErrorList.length) {
          const coownerPermissionUserMsg = coownerPremissionListByName.length
            ? `${i18n.t(
              'collab.tip.cannot'
            )}（${coownerPremissionListByName.join('、')}）`
            : ''
          const acceptedMsg = acceptedListByName.length
            ? `${i18n.t('collab.tip.already')}（${acceptedListByName.join(
              '、'
            )}）`
            : ''

          alert({
            title: `${i18n.t('collab.invited', [successCount || 0]) +
              i18n.t('unit.person')},${i18n.t('base.fail', [errorCount]) +
              i18n.t('unit.person')}`,
            message: `${i18n.t(
              'collab.fail.reason'
            )}：${coownerPermissionUserMsg + acceptedMsg}`
          }).then(() => {
            this.closeInvitePopup(loadingStatus)
          })
        } else {
          if (successCount > 0 && errorCount === 0) {
            // 完全成功
            toast.success(
              `${i18n.t('collab.invited', [successCount || 0])},${i18n.t(
                'base.fail',
                [errorCount]
              ) + i18n.t('unit.person')}`
            )
            setTimeout(() => {
              this.closeInvitePopup(loadingStatus)
            }, 1000)
          } else {
            // 部分成功
            let errors =
              result.errors.validation_errors || result.errors.external_errors
            if (errors.length > 0) {
              alert({
                title: `${i18n.t('collab.invited', [successCount || 0]) +
                  i18n.t('unit.person')},${i18n.t('base.fail', [errorCount]) +
                  i18n.t('unit.person')}`,
                message: `${i18n.t('collab.fail.reason')}：${
                  errors[0].error_tr_msg
                }`
              }).then(() => {
                this.closeInvitePopup(loadingStatus)
              })
            }
          }
        }
      })
    },
    closeInvitePopup (loadingStatus) {
      loadingStatus.clear()
      this.setState({
        collabState: {
          ...this.store.collabState,
          refreshCollabList: new Date().getTime()
        }
      })
      this.toggleQuery('invite')
    },
    toggleChangePerms () {
      if (this.actionItem.is_share_management && this.actionName === 'link') {
        this.toggleQuery('changepermssm')
      } else {
        this.toggleQuery('changeperms')
      }
    },
    toggleChangeCollabLevel () {
      this.setState({
        collabState: {
          ...this.store.collabState,
          currentRoleLevel: this.currentRoleLevel
        }
      })
      this.toggleQuery('collabLevel')
    },
    toggleAddMessage () {
      this.toggleQuery('addmessage')
    },
    toggleContactSelect () {
      this.toggleQuery('contactselect')
    },
    toggleSelectRemove () {
      this.toggleQuery('contactremove')
    },
    editMessage (description) {
      this.description = description
      this.toggleAddMessage()
    },
    createShare () {
      if (this.disabled) {
        toast(i18n.t('file.share.pleaseSelectMember'))
        return
      }
      const {
        perms: { access, due_time, password, disable_download, is_share_wps_edit },
        actionName,
        current_version,
        description
      } = this
      const group_ids = []
      const invited_user_ids = []
      this.selectList.forEach(id => {
        const item = this.selectEntities[id]
        if (item.is_group) {
          group_ids.push(item.is_department ? item.group_id : item.id)
        } else {
          invited_user_ids.push(item.id)
        }
      })
      let data = {
        access: actionName === 'link' ? access : 'collaborators',
        current_version,
        description,
        due_time,
        group_ids,
        invited_user_ids,
        disable_download,
        is_share_wps_edit,
        item_typed_id: this.actionItem.typed_id,
        password,
        password_protected: !!password
      }

      // 分享管控新增的字段设置
      if (this.actionItem.is_share_management && this.actionName === 'link') {
        if (this.perms.is_preview_limit) {
          data.is_preview_limit = true
          data.preview_limit = this.perms.preview_limit
        } else {
          let limit = this.perms.preview_limit
          if (limit <= 0) {
            if (this.actionItem.share_default_preview_limit > 0) {
              limit = this.actionItem.share_default_preview_limit
            } else {
              limit = 10
            }
          }
          data.is_preview_limit = false
          // 这里传了limit虽然没用，但是不传后端会报错
          data.preview_limit = limit
        }

        if (this.perms.is_download_limit_v2) {
          data.is_download_limit_v2 = true
          data.download_limit_v2 = this.perms.download_limit_v2
        } else {
          let limit = this.perms.download_limit_v2
          if (limit <= 0) {
            if (this.actionItem.share_default_download_limit > 0) {
              limit = this.actionItem.share_default_download_limit
            } else {
              limit = 10
            }
          }
          data.is_download_limit_v2 = false
          data.download_limit_v2 = limit
        }

        if (this.perms.is_watermark_customize_content) {
          data.is_watermark_customize_content = true
          data.watermark_customize_content = this.perms.watermark_customize_content
        } else {
          data.is_watermark_customize_content = false
          data.watermark_customize_content = ''
        }
      }

      ajax({
        data,
        url: CREATE_SHARE,
        parser: res => {
          if (actionName === 'link') {
            const shareUrl = `${config.imageUrl}/share/${res.share_link.unique_name}`

            if (
              !['Wechat', 'EnterpriseWechat'].includes(this.shareActionCategory)
            ) {
              alert({
                className: `clipbord-alert ${!this.enableClipboardJS &&
                  ' clipbord-disabled'}`,
                title: this.enableClipboardJS
                  ? i18n.t('file.share.copyLinkDialogTitle')
                  : i18n.t('file.share.selectAndCopyLinkDialogTitle'),
                message: shareUrl,
                confirmButtonText: this.enableClipboardJS
                  ? i18n.t('file.share.copyLinkConfirm')
                  : i18n.t('base.close')
              }).then(() => {
                this.$emit('close-share')
              })
            } else {
              if (document.querySelector('.input-clipboard-text')) return
              const input = document.createElement('input')

              input.setAttribute('type', 'hidden')
              input.setAttribute('class', 'input-clipboard-text')
              document.querySelector('.share-popup').append(input)
            }
            this.$nextTick().then(() => {
              if (this.enableClipboardJS) {
                if (
                  !['Wechat', 'EnterpriseWechat'].includes(
                    this.shareActionCategory
                  )
                ) {
                  let clipContent =
                    i18n.t('file.share.linkShareTips', [this.actionItem.name]) +
                    ' ' +
                    shareUrl +
                    (data.password_protected
                      ? i18n.t('file.share.passwordIs', [data.password])
                      : '')
                  document
                    .querySelector('.clipbord-alert .van-dialog__confirm')
                    .setAttribute('data-clipboard-text', clipContent)
                  const clipboard = new Clipboard(
                    '.clipbord-alert .van-dialog__confirm'
                  )

                  clipboard.on('success', () => {
                    toast(i18n.t('file.share.copyLinkSuccess'))
                  })
                  clipboard.on('error', e => {})
                } else {
                  this.initShare(shareUrl, this.actionItem)
                }
              }
            })
          } else {
            toast(i18n.t('file.share.success'))
            this.$emit('close-share')
          }
        }
      })
    },
    initShare (link, shareItem) {
      const loadingToast = loadingWithoutUserInterface()
      pageShare.ready &&
        pageShare.ready(pageShare => {
          const title = i18n.t('base.pageShareTitle', [config.product_name])

          pageShare.shareAll(
            {
              title,
              link,
              imgUrl: getPageShareIcon(shareItem),
              desc: shareItem.name
            },
            {
              accept_share_action: {
                shareAppMessage: data => {
                  data.title = shareItem.name + ' - '
                  if (
                    config.enterprise_info &&
                    config.enterprise_info.customized_share_link_page_title
                  ) {
                    data.title +=
                      config.enterprise_info.customized_share_link_page_title
                  } else {
                    data.title += title
                  }
                  return data
                }
              },
              share_action_category: this.shareActionCategory,
              callback: () => {
                loadingToast.clear()
                Toast.clear()
                this.handleClose('share')
              }
            }
          )
        })
    },
    handleRemoveItems (ids) {
      let newList = [...this.selectList]
      const newEntities = { ...this.selectEntities }
      ids.forEach(item_typed_id => {
        const index = newList.indexOf(item_typed_id)
        newList = [...newList.slice(0, index), ...newList.slice(index + 1)]
        delete newEntities[item_typed_id]
      })
      this.selectList = newList
      this.selectEntities = newEntities
    },
    onAdd (selectList, selectEntities) {
      this.selectList = [...this.selectList, ...selectList]
      this.selectEntities = { ...this.selectEntities, ...selectEntities }
    },
    fetchVersions () {
      const { id } = this.actionItem
      if (id) {
        ajax({
          url: `${VERSIONS_INFO}?file_id=${id}`
        }).then(res => {
          if (res && res.success) {
            this.fileVersion = res.file_versions[0].version
          }
        })
      }
    },
    handleActionBar () {
      if (this.$route.query.invite) {
        this.handleSendCollabInvite()
      } else {
        this.createShare()
      }
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';
.share-popup {
  height: 100%;
  display: flex;
  flex-direction: column;

  & .settings-title {
    color: var(--secondlyTitle);
    font-size: 12px;
    margin-left: 15px;
    height: 36px;
    line-height: 36px;
    border-bottom: 1px solid var(--sepLineColor);

    & .setting-more {
      color: #848484;
    }
  }

  & .nav-send-disabled .van-nav-bar__right .van-nav-bar__text {
    opacity: 0.4;
  }

  & .share-content {
    flex: 1 1 auto;
    overflow: auto;
    background-color: var(--pageBgColor);

    & .file-list {
      flex: 0 0 auto !important;
    }

    & .item-main {
      border-bottom: 1px solid var(--sepLineColor);
    }
  }

  & .invite-wrap {
    & .select-contact {
      margin-bottom: 0;
      margin-top: 19px;

      & > ul {
        border-bottom: 1px solid #e5e7e9;
      }
    }

    & .add-message-action {
      background-color: #fff;

      & .add-message-content {
        margin: 0 0 0 15px;
        padding-left: 0;
      }
    }
  }

  & .share-version {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 12px 0 13px 55px;
    position: relative;

    & .van-checkbox__icon {
      position: absolute;
      left: 30px;
      margin-top: 2px;
    }

    & .van-checkbox__label {
      line-height: 20px;
      margin-left: 0;
    }

    & .current-version {
      box-sizing: border-box;
      height: 14px;
      padding: 0 4px;
      font-size: 12px;
      border-width: 1px;
      border-style: solid;
      margin-left: 6px;
    }

    & .hint {
      color: var(--secondlyText);
      font-size: 12px;
      line-height: 17px;
    }
  }

  & .select-contact {
    background-color: #fff;
    margin-bottom: 10px;

    & ul {
      display: flex;
      margin: 15px 0 0 15px;
      flex-wrap: wrap;
    }

    & li {
      margin-right: 20px;
      margin-bottom: 15px;
    }

    & .contact-name {
      text-align: center;
      line-height: 17px;
      margin-top: 5px;
      max-width: 50px;
      font-size: 12px;
    }
  }

  & .add-contact,
  & .remove-contact {
    box-sizing: border-box;
    font-size: 40px;
    width: 50px;
    height: 50px;
    line-height: 50px;
    border-radius: 50px;
    border: 1px dashed #d1d4df;
    text-align: center;
    color: var(--contentIcon);
  }

  & .svg-contact {
    width: 50px;
    height: 50px;
  }

  & .permission-settings {
    background-color: #fff;
    margin-bottom: 10px;

    & .settings-content {
      display: flex;
      padding: 10px 15px;

      & ul {
        font-size: 12px;
        line-height: 22px;
        flex: 1 1 auto;

        & .iconfont {
          color: var(--contentIcon);
          transform: scale(0.8);
          margin-right: 10px;
        }
      }
    }

    & .icon-arrow-next {
      color: var(--contentIcon);
      flex: 0 0 auto;
      align-self: center;
    }
  }

  & .add-message-action {
    flex: 1 1 auto;

    & .add-message-content {
      display: flex;
      justify-content: space-between;
      background-color: #fff;
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      margin-bottom: 10px;
    }

    & .hint {
      color: #848484;

      & .icon-arrow-next {
        color: var(--contentIcon);
      }
    }
  }

  & .add-message-tip {
    color: #8894a1;
    font-size: 12px;
    height: 38px;
    margin: 6px 0 0 15px;
  }

  & .action-bar {
    flex: 0 0 auto;
    justify-content: space-between;
    border-top: 1px solid rgba(191, 191, 191, 0.5);
    height: 49px;
    line-height: 49px;
    background-color: #ffffff;
    text-align: center;
    box-shadow: 0 -0.5px 5px 0 rgba(191, 191, 191, 0.5);
    font-size: 18px;
    border-top-color: #d7d8da;

    &.disabled {
      color: #dadada;
    }
  }
}

.clipbord-alert {
  & .van-dialog__header {
    padding-left: 18px;
    padding-right: 18px;
  }

  & .van-dialog__message {
    word-break: break-all;
  }

  &.clipbord-disabled {
    & .van-dialog__confirm,
    & .van-dialog__confirm:active {
      color: #000;
    }
  }
}
</style>
